var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: "核销订单：" + _vm.orderInfo.orderId,
        "before-close": _vm.close,
        width: "70%",
        "custom-class": "write-off-form",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "pb16 pl16 pr16" },
        [
          _c("div", { staticClass: "write-off-content" }, [
            _vm._v("确定核销该订单吗？"),
          ]),
          _c(
            "div",
            { staticClass: "image-section" },
            [
              _c("div", { staticClass: "section-header" }, [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v(" 图片凭证 "),
                ]),
                _c("div", { staticClass: "image-count" }, [
                  _vm._v(" " + _vm._s(_vm.images.length) + "/5 "),
                ]),
              ]),
              _c("ImagePicker", {
                attrs: {
                  "max-count": 5,
                  "min-count": 1,
                  "max-width": 2000,
                  quality: 0.8,
                },
                model: {
                  value: _vm.images,
                  callback: function ($$v) {
                    _vm.images = $$v
                  },
                  expression: "images",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "mb20", attrs: { type: "flex", justify: "end" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !this.images.length },
                  on: { click: _vm.onWriteOff },
                },
                [_vm._v("确定")]
              ),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }